/* eslint-disable react/jsx-no-constructed-context-values */
import React, { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react';

export type CompanyLinkedInId = 'e-butler' | 'hassan-allam-holding' | 'orascom-construction-plc' | '4s-technology';

export const ExperienceDetailsContext = createContext<{
  id?: CompanyLinkedInId;
  setId: Dispatch<SetStateAction<CompanyLinkedInId | undefined>>;
}>({
  setId: () => {},
});
function ExperienceDetailsProvider({ children }: { children: ReactNode }) {
  const [id, setId] = useState<CompanyLinkedInId | undefined>(undefined);

  return (
    <ExperienceDetailsContext.Provider
      value={{
        id,
        setId,
      }}>
      {children}
    </ExperienceDetailsContext.Provider>
  );
}

export default ExperienceDetailsProvider;

export const useExperienceDetailsContext = () => {
  const context = useContext(ExperienceDetailsContext);

  if (!context) {
    throw new Error('useExperienceDetailsContext must be used within an ExperienceDetailsProvider');
  }

  return context;
};
